import { action, makeObservable, observable } from "mobx";
import { IRootStore } from "../types/IRootStore";

interface IAnnotatedAttachment {
  url: string;
  attributes: {
    leadId: string;
    filename: string;
    [key: string]: unknown;
  };
  [key: string]: unknown;
}

const defaultAnnotatedAttachment: IAnnotatedAttachment = {
  url: "",
  attributes: {
    leadId: "",
    filename: "",
  },
};

export class AnnotationStore {
  rootStore: IRootStore;

  @observable annotatedAttachment: IAnnotatedAttachment = defaultAnnotatedAttachment;

  @observable annotatingAttachment = false;

  @observable isSaving = false;

  constructor(rootStore: IRootStore) {
    makeObservable(this);
    this.rootStore = rootStore;
  }

  setAnnotatedAttachment = action((attachment: IAnnotatedAttachment) => {
    this.annotatedAttachment = attachment;
  });

  setAnnotatingAttachment = action((annotating: boolean) => {
    this.annotatingAttachment = annotating;
  });

  setIsSaving = action((val: boolean) => {
    this.isSaving = val;
  });
}

export default AnnotationStore;
